module.exports = __webpack_public_path__ + "img/666.4fb84618.jpeg";